// constants/theme.js
import { COLORS, GRADIENTS } from './colors';

export const THEME = {
  colors: COLORS,
  gradients: {
    ...GRADIENTS,
       button: GRADIENTS.button,           // ["#14A896", "#0A9688"] - Dégradé bouton teal lumineux
    card: GRADIENTS.card,               // ["#FFFFFF", "#F0FAFA"] - Cartes blanc → blanc teal
    background: GRADIENTS.background,
  },

  typography: {
    title: {
      fontSize: "28px",
      fontWeight: '800',
      color: COLORS.primary.main,
      lineHeight: 1.2,
    },
    subtitle: {
      fontSize: "18px",
      fontWeight: '600',
      color: COLORS.primary.sky,
      lineHeight: 1.4,
    },
    sectionTitle: {
      fontSize: "20px",
      fontWeight: '700',
      color: COLORS.primary.lavender,
      lineHeight: 1.3,
    },
    body: {
      fontSize: "15px",
      fontWeight: '400',
      color: COLORS.neutral.dark,
      lineHeight: 1.5,
    },
    caption: {
      fontSize: "12px",
      color: COLORS.neutral.gray,
      lineHeight: 1.4,
    },
    small: {
      fontSize: "13px",
      color: COLORS.neutral.gray,
      lineHeight: 1.4,
    }
  },

  spacing: {
    xs: "4px",
    sm: "8px",
    md: "12px",
    lg: "16px",
    xl: "24px",
    xxl: "32px",
    xxxl: "48px"
  },

  borderRadius: {
    sm: "6px",
    md: "10px",
    lg: "16px",
    xl: "22px",
    pill: "50px",
  },

  shadows: {
    sm: `
      box-shadow: 0 1px 3px rgba(45, 140, 255, 0.1);
    `,
    md: `
      box-shadow: 0 3px 6px rgba(45, 140, 255, 0.15);
    `,
    lg: `
      box-shadow: 0 6px 10px rgba(45, 140, 255, 0.2);
    `,
    card: `
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
      border: 1px solid ${COLORS.neutral.light};
    `
  },

  breakpoints: {
    mobile: '768px',
    tablet: '1024px',
    desktop: '1200px'
  }
};